import { ComparisonResultsCard } from './comparison-results-card'
import { isRadioButton } from '../util'
import { MyPicksPageCard } from './my-picks-page-card'

export class VehicleCardFactory {
    public constructor(public wrapper: HTMLElement) {
        if (isRadioButton()) {
            new ComparisonResultsCard(wrapper)
        } else {
            new MyPicksPageCard(wrapper)
        }
    }
}
